import { Box, Text, Group, Badge } from '@mantine/core'
import { IconQuote } from '@tabler/icons-react'

const typeBadgeColors = {
  text_input: 'cyan',
  choice: 'teal',
}

export function EvidenceQuote({ evidence }) {
  const { type, beat_context, player_text, choice_text, analysis } = evidence
  const quoteText = player_text || choice_text

  return (
    <Box
      style={{
        borderLeft: '3px solid rgba(0, 229, 255, 0.5)',
        paddingLeft: 16,
        marginBottom: 12,
      }}
    >
      <Group gap={8} mb={6}>
        <IconQuote size={14} color="rgba(0, 229, 255, 0.5)" />
        <Badge
          size="xs"
          variant="light"
          color={typeBadgeColors[type] || 'cyan'}
          tt="capitalize"
        >
          {type === 'text_input' ? 'Text Response' : 'Choice'}
        </Badge>
        {beat_context && (
          <Text size="xs" c="dimmed" fs="italic">
            {beat_context}
          </Text>
        )}
      </Group>

      {quoteText && (
        <Text
          size="sm"
          c="cyan.2"
          ff="Rajdhani, sans-serif"
          fw={500}
          mb={6}
          style={{
            background: 'rgba(0, 229, 255, 0.04)',
            padding: '8px 12px',
            borderRadius: 4,
            lineHeight: 1.5,
          }}
        >
          "{quoteText}"
        </Text>
      )}

      {analysis && (
        <Text size="xs" c="dimmed" lh={1.4}>
          {analysis}
        </Text>
      )}
    </Box>
  )
}
